import { render, staticRenderFns } from "./historiqueCotation.vue?vue&type=template&id=ba597bd0&"
import script from "./historiqueCotation.vue?vue&type=script&lang=js&"
export * from "./historiqueCotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports